module.exports = __webpack_public_path__ + "media/images/flags/32/Belgium-04812a35b5f83ceddd2181e1171c2f4e.png";